import { FormInstance } from "antd";
import { isArray, isEmpty, isEqual } from "lodash";

const onClearFormErrors = (form: FormInstance) => (values: any) => {
  if (isArray(values)) {
    values.forEach((row) => {
      row.name.forEach((name: string) => {
        const error = form.getFieldError(name);
        if (!error.length) {
          return;
        }
        form.setFields([
          {
            name: name,
            errors: [],
          },
        ]);
      });
    });

    return;
  }

  Object.keys(values).forEach((field) => {
    const error = form.getFieldError(field);
    if (!error.length) {
      return;
    }
    form.setFields([
      {
        name: field,
        errors: [],
      },
    ]);
  });
};

const isFormValueChanged = (values: any) => (_: any, initial: any) => {
  return Object.keys(values).some((key) => {
    if (isEmpty(values?.[key]) && isEmpty(initial?.[key])) {
      return false;
    }

    return !isEqual(values?.[key], initial?.[key]);
  });
};

const formItemNoMarginBottom = { style: { marginBottom: 0 } };
const formItemMarginTop = { style: { marginTop: 8 } };
const showHelpText = (data: string | undefined) => {
  if (!data) {
    return "";
  }

  return `(${data})`;
};

export { onClearFormErrors, isFormValueChanged, formItemNoMarginBottom, formItemMarginTop, showHelpText };
